import { render, staticRenderFns } from "./XHeader.vue?vue&type=template&id=7e89f065&"
import script from "./XHeader.vue?vue&type=script&lang=js&"
export * from "./XHeader.vue?vue&type=script&lang=js&"
import style0 from "./XHeader.vue?vue&type=style&index=0&id=7e89f065&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports